import { Box, Typography } from "@material-ui/core";
import { convertPriceToDollarFormat } from "../../../helpers/methods";
import ArrowIcon from "../../../assets/icons/pay-arrow.svg";
import checkoutFooterStyles from "./CheckoutFooter.styles";

interface CheckoutFooterProps {
  subtotal: number;
  discount: number;
  tax: number;
  itemCount: number;
  onCheckout: () => void;
  disabled?: boolean;
  showBackButton?: boolean;
  onBackClick?: () => void;
  buttonText?: string;
  backButtonText?: string;
}

const CheckoutFooter = ({
  subtotal,
  discount,
  tax,
  itemCount,
  onCheckout,
  disabled = false,
  showBackButton = false,
  onBackClick,
  buttonText = "Checkout",
  backButtonText = "Back",
}: CheckoutFooterProps) => {
  const classes = checkoutFooterStyles();

  return (
    <Box className={classes.footerContainer}>
      {/* Order Summary Section */}
      <Box className={classes.summarySection}>
        <Box className={classes.summaryRow}>
          <Typography className={classes.summaryLabel}>Subtotal</Typography>
          <Typography className={classes.summaryValue}>
            {convertPriceToDollarFormat(subtotal)}
          </Typography>
        </Box>
        
        {discount > 0 && (
          <Box className={classes.summaryRow}>
            <Typography className={classes.summaryLabel}>Discount</Typography>
            <Typography className={classes.discountValue}>
              -{convertPriceToDollarFormat(discount)}
            </Typography>
          </Box>
        )}
        
        <Box className={classes.summaryRow}>
          <Typography className={classes.summaryLabel}>Tax</Typography>
          <Typography className={classes.summaryValue}>
            {convertPriceToDollarFormat(tax)}
          </Typography>
        </Box>
      </Box>

      {/* Checkout Button */}
      <Box className={classes.checkoutButtonContainer}>
        <Box className={showBackButton ? classes.buttonRow : undefined}>
          {showBackButton && (
            <Box
              className={classes.backButton}
              onClick={onBackClick}
            >
              <Typography className={classes.backButtonText}>{backButtonText}</Typography>
            </Box>
          )}
          <Box
            className={`${classes.checkoutButton} ${disabled ? classes.checkoutButtonDisabled : ''} ${showBackButton ? classes.checkoutButtonFlex : ''}`}
            onClick={disabled ? undefined : onCheckout}
          >
            <Box className={classes.checkoutContent}>
              <Typography className={classes.checkoutText}>{buttonText}</Typography>
              <Box className={classes.itemCountContainer}>
                <Typography className={classes.itemCount}>
                  {itemCount}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CheckoutFooter;
